module.exports = __webpack_public_path__ + "1.5.0-unryo/img/step2.c457e560.png";